<ng-container *transloco="let t">
  <div [class.dark-theme]="isFullScreen && darkMode" [class.full-screen]="isFullScreen" [class.h-100]="isFullScreen">
  <div class="live-results"
       [class.pb-300-228]="isFullScreen">
    @if (race && isFullScreen) {
      <ng-template [ngTemplateOutlet]="fullScreenHeader"></ng-template>
      @if (rankingEnabled) {
        <ng-template [ngTemplateOutlet]="rankingSelect"></ng-template>
      }
      @if (fullScreenMode === FullScreenMode.FINAL_RANKING) {
        <ng-template [ngTemplateOutlet]="ranking"></ng-template>
    }
      @else if (fullScreenMode === FullScreenMode.FULL) {
        <ng-template [ngTemplateOutlet]="results"></ng-template>
      } @else {
        <ng-template [ngTemplateOutlet]="splitResults"></ng-template>
      }
    } @else {
      <app-page-template [showBreadcrumbs]="false">
        <app-carousel [images]="[image]" [showGradient]="true"></app-carousel>
        <ng-template [ngTemplateOutlet]="header"></ng-template>
        <ng-template [ngTemplateOutlet]="results"></ng-template>
      </app-page-template>
    }

    <ng-template #fullScreenHeader>
      <div class="mb-1" [class.dark-mode]="isFullScreen && darkMode">
        <app-live-results-heading [race]="race" [countries]="countries" [languages]="languages" [event]="event" [isFullScreen]="isFullScreen"
                                  [finished]="finishedCount ?? 0" [started]="startedCount ?? 0" [darkMode]="isFullScreen && darkMode"
                                  [type]="LiveResultHeadingType.RACE"
                                  [isSplitScreen]="fullScreenMode === FullScreenMode.SPLIT"
                                  [showRanking]="rankingEnabled"
                                  (onToggleDarkMode)="onToggleDarkMode($event)"
                                  (onShowRankingToggle)="onShowRankingToggle($event)"
                                  (onSplitScreen)="toggleView()"/>
      </div>
    </ng-template>


    <ng-template #resultsTable>
      <div class="live-results-card" [class.pb-40-48]="!isFullScreen">
        <app-live-results-table-body [competitorLiveResults]="filteredLiveResults ?? []" [measurementType]="measurementType" [race]="race"  [event]="event"
                                     [languages]="languages" [isDarkMode]="isFullScreen && darkMode"
                                     [fullScreenMode]="fullScreenMode ?? FullScreenMode.FULL"
                                     [raceSettings]="race?.raceSettings" [gender]="gender" [category]="category" [isFinished]="isFinished" [isCarousel]="isCarousel"
                                     [isRoundRace]="isRoundRace" [isFullScreen]="isFullScreen"/>
      </div>
      @if (!isFullScreen) {
        <ng-template [ngTemplateOutlet]="actionButtons"></ng-template>
      }
    </ng-template>

    <ng-template #header>
      <div class="container pt-62-32">
        <app-live-results-heading [race]="race" [countries]="countries" [languages]="languages"
                                  [finished]="finishedCount ?? 0" [started]="startedCount ?? 0" [event]="event"
                                  [type]="LiveResultHeadingType.RACE"/>
      </div>
    </ng-template>


    <ng-template #actionButtons>
      <div class="pe-3">
        <div class="d-flex align-items-center justify-content-end py-3">
          <app-button-alt [borderColor]="'var(--teal-500)'" [textColor]="'var(--grey-neutral-800)'"
                          [buttonColor]="isFullScreen ? 'var(--teal-50)' : 'transparent'" [text]="t(  'app.common.back')"
                          (onClickCallback)="back()"></app-button-alt>
        </div>
      </div>
    </ng-template>

    <ng-template #splitResults>
      <div class="px-3">
        <div class="row">
          <div class="col-6">
            <div class="section-title-wrapper">
              <span class="section-title">
                {{t('app.common.gender.1') | uppercase}}
              </span>
            </div>
            <div class="live-results-card">
              <app-live-results-table-body [competitorLiveResults]="liveResultMale ?? []" [gender]="1" [isFinished]="isFinished"
                                           [raceSettings]="race?.raceSettings" [isRoundRace]="isRoundRace" [race]="race"  [event]="event"
                                           [languages]="languages" [isDarkMode]="isFullScreen && darkMode"
                                           [fullScreenMode]="fullScreenMode ?? FullScreenMode.FULL"
                                           [measurementType]="measurementType" [isFullScreen]="isFullScreen" [isCarousel]="isCarousel"/>
            </div>
          </div>
          <div class="col-6">
            <div class="section-title-wrapper">
              <span class="section-title">
                {{t('app.common.gender.2') | uppercase}}
              </span>
            </div>
            <div class="live-results-card">
              <app-live-results-table-body [competitorLiveResults]="liveResultFemale ?? []" [gender]="2" [race]="race"  [event]="event"
                                           [languages]="languages" [isDarkMode]="isFullScreen && darkMode"
                                           [fullScreenMode]="fullScreenMode ?? FullScreenMode.FULL"
                                           [raceSettings]="race?.raceSettings" [isRoundRace]="isRoundRace" [isFinished]="isFinished"
                                           [measurementType]="measurementType" [isFullScreen]="isFullScreen" [isCarousel]="isCarousel"/>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #results>
      <div [class.padding-bottom-92]="!isFullScreen" [class.container]="!isFullScreen"
           [class.full-screen-container]="isFullScreen" [class.pb-300-228]="!isFullScreen"
           [class.mt-21]="!isFullScreen">
        <ng-template [ngTemplateOutlet]="resultsTable"></ng-template>
      </div>
    </ng-template>

    <ng-template #ranking>
      <div class="live-results-card">
        <app-live-results-table-body [competitorLiveResults]="rankingList ?? []"
                                     [race]="race"
                                     [event]="event"
                                     [languages]="languages"
                                     [isDarkMode]="isFullScreen && darkMode"
                                     [fullScreenMode]="fullScreenMode ?? FullScreenMode.FINAL_RANKING"
                                     [raceSettings]="race?.raceSettings"
                                     [isRoundRace]="isRoundRace" [isFinished]="true"
                                     [measurementType]="measurementType"
                                     [category]="selectedCategory?.id"
                                     [gender]="selectedGender === Gender.MALE ? 1 : selectedGender === Gender.FEMALE ? 2 : undefined"                                     [isFullScreen]="isFullScreen" [isCarousel]="false"/>
      </div>
    </ng-template>

    <ng-template #rankingSelect>
      @if (categoriesForRanking.length) {
        <ng-template [ngTemplateOutlet]="categorySelect"></ng-template>
      }
      @else {
      <ng-template [ngTemplateOutlet]="genderSelect"></ng-template>
      }

    </ng-template>

    <ng-template #genderSelect>
      <div class="">
        <div ngbDropdown>
          <button class="category-title-btn" ngbDropdownToggle>
            {{t('events.finished.events.results')}} - {{ selectedGender ? t('app.common.gender.' + selectedGender) : t('app.common.all') }}
          </button>
          <div ngbDropdownMenu>
            <button ngbDropdownItem
                    [class.active]="selectedGender === Gender.MALE"
                    (click)="selectGender(Gender.MALE)">
              {{ t('app.common.gender.1') }}
            </button>
            <button ngbDropdownItem
                    [class.active]="selectedGender === Gender.FEMALE"
                    (click)="selectGender(Gender.FEMALE)">
              {{ t('app.common.gender.2') }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #categorySelect>
      <div class="">
        <div ngbDropdown>
          <button class="category-title-btn" ngbDropdownToggle>
            {{t('events.finished.events.results')}} - {{ selectedCategory ? selectedCategory.name : t('app.common.all') }}
          </button>
          <div ngbDropdownMenu>
            @for (category of categoriesForRanking; track category.id) {
            <button ngbDropdownItem
                    [class.active]="selectedCategory?.id === category.id"
                    (click)="selectCategory(category)">
            {{ category.name }}
            @if (category.code) {
            <span class="category-code ms-1">({{ category.code }})</span>
            }
            </button>
            }
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  </div>
</ng-container>
